import { Box, List } from '@mui/material';
import React, { ReactNode } from 'react';

import { Divider } from '@sumologic/yama-ds-components';

export interface TreeProps {
  children?: ReactNode;
  className?: any;
}

export const Tree = ({ children, ...rest }: TreeProps) => (
  <Box fontSize='.75rem' margin={0} padding={0} position='relative' {...rest}>
    <Divider
      orientation='vertical'
      sx={{
        left: 0,
        position: 'absolute',
      }}
    />
    <List
      sx={{
        listStyle: 'none',
      }}
    >
      {children}
    </List>
  </Box>
);
